import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/** หัวข้อใหญ่ประจำ section (มีไอคอนสี่เหลี่ยมมนด้านหน้า) */
export const SectionTitle: React.FC<{ icon: IconDefinition; iconColor: string; children: React.ReactNode }> = ({ icon, iconColor, children }) => (
  <h2 className="text-xl font-bold text-gray-800 dark:text-slate-100 flex items-center gap-3 mb-5">
    <span className={`w-9 h-9 rounded-lg flex items-center justify-center text-white text-sm ${iconColor}`}>
      <FontAwesomeIcon icon={icon} />
    </span>
    {children}
  </h2>
);

/**
 * หัวข้อย่อยในการ์ด endpoint (Request Body / Response / Status Values ...)
 * spacing รับเฉพาะ margin-top (margin-bottom ตรึงไว้ที่ mb-3 เพื่อไม่ให้ class ชนกัน)
 */
export const SubHeading: React.FC<{
  icon: IconDefinition;
  iconClassName?: string;
  spacing?: string;
  children: React.ReactNode;
}> = ({ icon, iconClassName = 'text-gray-400 dark:text-slate-500 text-xs', spacing = '', children }) => (
  <h4 className={`font-bold text-gray-700 dark:text-slate-200 text-sm mb-3 flex items-center gap-2 ${spacing}`.trim()}>
    <FontAwesomeIcon icon={icon} className={iconClassName} /> {children}
  </h4>
);

/**
 * หัวข้อระดับ block ในหน้า
 * ส่ง margin/color เป็น prop แทนการต่อท้าย className เพราะ Tailwind ตัดสินจากลำดับใน stylesheet
 * (เช่น "mb-3 mb-2" จะได้ mb-3 ไม่ใช่ mb-2)
 */
export const BlockHeading: React.FC<{
  color?: string;
  margin?: string;
  children: React.ReactNode;
}> = ({ color = 'text-gray-700 dark:text-slate-200', margin = 'mb-3', children }) => (
  <h3 className={`font-bold ${color} text-sm ${margin}`}>{children}</h3>
);

/** หัวข้อระดับ block พร้อมไอคอน */
export const BlockHeadingIcon: React.FC<{
  icon: IconDefinition;
  iconClassName?: string;
  color?: string;
  margin?: string;
  children: React.ReactNode;
}> = ({ icon, iconClassName = 'text-gray-400 dark:text-slate-500 text-xs', color = 'text-gray-700 dark:text-slate-200', margin = 'mb-3', children }) => (
  <h3 className={`font-bold ${color} text-sm flex items-center gap-2 ${margin}`}>
    <FontAwesomeIcon icon={icon} className={iconClassName} /> {children}
  </h3>
);
